<template>
  <b-form-group>
    <template #label>
      <div class="d-flex mb-4">
        <b-form-checkbox
          v-if="checkbox"
          v-model="allSelected"
          aria-describedby="cartItems"
          aria-controls="cartItems"
          style="margin-top: auto; margin-bottom: auto"
          class="button__chack-all-mc"
          @change="toggleAll"
        >
        </b-form-checkbox>
        <b-row class="cart__items-label font-weight-bold mx-0 w-100">
          <b-col cols="5" lg="6" class="px-1">Micro-Credentials</b-col>
          <b-col cols="3" lg="2" class="px-1">Type</b-col>
          <b-col cols="3" class="px-1">Price</b-col>
          <b-col cols="1" class="px-1">Action</b-col>
        </b-row>
      </div>

      <b-form-checkbox-group
        id="items"
        v-model="$_selected"
        name="items"
        class="cart__items-list"
        stacked
      >
        <span
          v-for="(item, index) in cartItems"
          :key="`item__index-${index}`"
          :ref="`item__index-${index}`"
        >
          <hr />
          <div class="d-flex row__mc-item">
            <b-form-checkbox
              :ref="`item__index-${index}-checkbox`"
              :value="item.id"
              :disabled="!item.is_available"
              style="margin-top: auto; margin-bottom: auto"
              class="button__chack-mc"
            >
            </b-form-checkbox>
            <b-row class="mx-0 w-100 cart__items">
              <b-col cols="5" lg="6" class="pl-1 pr-3">
                <b-row>
                  <b-col cols="12" lg="5">
                    <div :key="`thumbnail--${item.learning_unit.id}`" class="cart__thumbnail mb-2">
                      <b-img
                        :ref="`item__index-${index}-img`"
                        class="rounded img__learning-unit"
                        :class="!item.is_available ? 'img__learning-unit__disabled' : ''"
                        :src="
                          item.learning_unit.media_detail && item.learning_unit.media_detail[0]
                            ? item.learning_unit.media_detail[0].url
                            : require('@/assets/default-lu-cover.jpg')
                        "
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="12" lg="7" class="px-0">
                    <div class="d-flex flex-column justify-content-between h-100">
                      <router-link
                        :is="!item.is_available ? 'span' : 'router-link'"
                        :key="`${item.learning_unit.id}`"
                        :to="{
                          name: 'micro-credentials/detail',
                          params: { learningUnitId: item.learning_unit.id }
                        }"
                      >
                        <div
                          :ref="`item__index-${index}-text-mc-name`"
                          class="text__mc-name font-size-md text-black px-3"
                          :class="!item.is_available ? 'text-muted' : ''"
                        >
                          {{ item.learning_unit.name }}
                        </div>
                      </router-link>

                      <div
                        v-if="item.learning_unit_option.isQuota"
                        class="p-0 mb-2 mx-2 text__quota-description"
                        :class="!item.is_available ? 'text-muted' : ''"
                      >
                        <vue-show-more-text
                          :ref="`item__index-${index}-text-quota-description`"
                          :text="
                            item.learning_unit_option.option_name == 'Learn Quota Option'
                              ? 'Learn and +2 Submission quota'
                              : '+2 Submission quota'
                          "
                        >
                        </vue-show-more-text>
                      </div>

                      <div
                        v-if="
                          !item.is_available && item.isModeUnavaliable && item.hasAvailableModes
                        "
                        :ref="`item__index-${index}-text-alert-unavailable`"
                        class="text-danger px-3"
                      >
                        Unavailable, please change MC type.
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="3" lg="2" class="d-flex px-1">
                <span
                  :ref="`item__index-${index}-text-mc-type`"
                  style="margin-top: auto; margin-bottom: auto"
                  :class="!item.is_available ? 'text-muted' : ''"
                >
                  <div
                    v-if="
                      !item.is_available &&
                      (!item.hasAvailableModes || item.learning_unit_option.isQuota)
                    "
                  >
                    Unavailable
                  </div>

                  <vue-show-more-text
                    v-else-if="item.learning_unit_option.isQuota"
                    class="text__type"
                    :text="
                      item.learning_unit_option.option_name == 'Learn Quota Option'
                        ? 'Learn + Quota'
                        : 'Quota'
                    "
                  >
                  </vue-show-more-text>

                  <b-dropdown
                    v-else
                    :text="
                      item.isModeUnavaliable
                        ? 'Change MC Type'
                        : textMode[item.learning_unit_option.mode]
                    "
                    class="button__dropdown-mc-type text__type"
                    :variant="item.isModeUnavaliable ? 'outline-danger' : 'outline-primary'"
                  >
                    <b-dropdown-header variant="dark" style="font-weight: bold">
                      <template>
                        <div class="dd-header">Type</div>
                      </template>
                    </b-dropdown-header>
                    <b-dropdown-item
                      :active="item.learning_unit_option.mode == 'VERIFY'"
                      :disabled="!item.learning_unit.open_apply_verify"
                      @click.prevent="onChangeEntryMode(item.id, 'VERIFY')"
                      >{{ textMode.VERIFY }}</b-dropdown-item
                    >
                    <b-dropdown-item
                      :active="item.learning_unit_option.mode == 'LEARN_VERIFY'"
                      :disabled="!item.learning_unit.open_apply_learn"
                      @click.prevent="onChangeEntryMode(item.id, 'LEARN_VERIFY')"
                      >{{ textMode.LEARN_VERIFY }}</b-dropdown-item
                    >
                  </b-dropdown>
                </span>
              </b-col>
              <b-col class="d-flex px-1">
                <div
                  :ref="`item__index-${index}-text-mc-price`"
                  cols="3"
                  class="d-flex px-1"
                  :class="!item.is_available ? 'text-muted' : ''"
                >
                  <div v-if="!item.is_available" class="text__price font-weight-bold">None</div>

                  <price-displayer
                    v-else
                    class="text__price"
                    :normal-price="item.learning_unit_option.price"
                    :discount-price="item.learning_unit_option.discount_price"
                    is-currency-form
                  >
                  </price-displayer>

                  <!-- <div
                    v-if="
                      item.learning_unit_option.isQuota
                        ? !isVerifyQuota(item) && !item.is_available
                        : !item.learning_unit.is_published ||
                          (!item.is_available && item.isModeUnavaliable)
                    "
                    class="text__price font-weight-bold"
                  >
                    None
                  </div>
                  <price-displayer
                    v-else
                    class="text__price"
                    :normal-price="
                      item.learning_unit_option.mode == 'VERIFY'
                        ? item.learning_unit.price_verify
                        : item.learning_unit.price_verify_learn
                    "
                    :discount-price="
                      item.learning_unit_option.mode == 'VERIFY'
                        ? item.learning_unit.price_verify_discount
                        : item.learning_unit.price_verify_learn_discount
                    "
                    is-currency-form
                  ></price-displayer> -->
                </div>
              </b-col>
              <b-col cols="1" class="d-flex text-danger text__action-delete px-1">
                <span
                  :ref="`item__index-${index}-button-delete`"
                  style="margin-top: auto; margin-bottom: auto; cursor: pointer"
                  class="button__delete-mc"
                  @click="deleteItem(item.id)"
                >
                  Delete
                </span>
              </b-col>
            </b-row>
          </div>
        </span>
      </b-form-checkbox-group>
    </template>
  </b-form-group>
</template>

<script>
import PriceDisplayer from '@/views/LearningUnitExplore/components/PriceDisplayer';
import vueShowMoreText from 'vue-show-more-text';
import CartItem from '@/models/CartItem';
export default {
  name: 'CartItemLists',

  components: {
    PriceDisplayer,
    vueShowMoreText
  },

  model: {
    prop: 'vModel',
    event: 'change'
  },

  props: {
    cartItems: {
      type: Array,
      default: () => []
    },
    checkbox: {
      type: Boolean,
      default: true
    },
    vModel: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      allSelected: false,
      textMode: {
        VERIFY: 'Verify',
        LEARN_VERIFY: 'Verify + Learn'
      }
    };
  },
  computed: {
    $_selected: {
      get() {
        return this.vModel;
      },
      set(v) {
        return this.$emit('change', v);
      }
    }
  },

  watch: {
    $_selected(newValue) {
      const itemsIsAvaliable = this.getAvailableCartItems();

      if (newValue.length === 0) {
        this.allSelected = false;
      } else if (newValue.length === itemsIsAvaliable.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    }
  },

  methods: {
    getAvailableCartItems() {
      return this.cartItems.filter((item) => item.is_available);
    },

    toggleAll(checked) {
      this.$_selected = checked
        ? this.getAvailableCartItems()
            .map(({ id }) => id)
            .filter(Boolean)
        : [];
    },

    // isVerifyQuota(item) {
    //   return (
    //     item.learning_unit.is_published == false &&
    //     item.learning_unit_option.option_type == 'QUOTA' &&
    //     item.learning_unit_option.mode == 'VERIFY'
    //   );
    // },

    srcImg(learning_unit) {
      return learning_unit.media_detail && learning_unit.media_detail[0]
        ? { backgroundImage: `url(${learning_unit.media_detail[0].url})` }
        : require('@/assets/default-lu-cover.jpg');
    },

    async deleteItem(itemId) {
      const res = await CartItem.api().deleteItem(itemId);
      if (res.response.status == 200) {
        CartItem.delete(itemId);
        this.$toast.open({
          message: 'Micro-Credentials has been deleted from the cart.',
          type: 'success',
          pauseOnHover: true
        });
      }
      this.$emit('delete:success', itemId);
    },

    async onChangeEntryMode(id, mode) {
      await CartItem.api().updateEntry(id, {
        mode
      });
    }
  }
};
</script>

<style lang="scss">
.text-muted .text__discount-price {
  color: #d1d2db !important;
}

.text__discount-price {
  // color: #3c44b1;
  color: #3b3e66;
}

.cart__items-list > span:nth-child(1) hr {
  display: none;
}

.cart__thumbnail {
  position: relative;
  overflow: hidden;
  aspect-ratio: auto;
  min-width: 160px;
  max-width: 270px;
  height: 120px;

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    object-fit: var(--object-fit);
  }
}

.img__learning-unit {
  &__disabled {
    filter: grayscale(30%);
    opacity: 0.5;
  }
}

.text {
  &__mc-name {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-wrap: break-word;
  }

  &__mode {
    word-break: break-word;
    margin-top: auto;
    margin-bottom: auto;
  }

  &__price {
    word-break: break-word;
    margin-top: auto;
    margin-bottom: auto;
  }
}

.button__dropdown-mc-type button {
  padding-left: 1rem;
  padding-right: 0.7rem;
}

.dd-header {
  font-weight: bold;
  color: black;
  font-size: medium;
  padding: 0;
}
.text__quota-description {
  color: #3b3e66;
  font-size: 16px;
}
</style>
